<template>
  <div class="container">
    <NavBar />
    <div class="bg-image"></div>
    <div class="bg-tint"></div>
    <div class="textbox">
    <h1 class="unselectable">Trigenda Digi</h1>
    <h3 class="unselectable">Uusi tapa tehdä ammatillista kohtaamistyötä.</h3>
    <router-link to="/Conversation">
        <button id="startBTN">Aloita</button>
    </router-link>
    </div>
  </div>
</template>

<script>
import Deck from '../services/deck.js';
import Card from '../components/Card.vue';
import Answer from '../components/Answer.vue';
import Login from '../components/Login.vue';
import NavBar from '../components/Navbar.vue';

export default {
    name: 'Main',
    props: {
        msg: String,
    },
    components: {
        Card,
        Answer,
        Login,
        NavBar
    },
    setup() {
        const deckObject = new Deck();
        const cards = deckObject.cards;

        // T console.log(cards);
        return { cards };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.container {
  height: 95vh;
}

.bg-image {
  background-image: url('../assets/start_bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 95vh;
  filter: blur(3px);
  z-index: 0;
}

.bg-tint {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #76B2BA;
  opacity: 0.4;
  z-index: 1;
}

.textbox {
  position: fixed;
  top: 10%;
  right: 10%;
  left: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 70vh;
  z-index: 50;
}

.textbox p {
  margin: 2px;
}

#startBTN {
    background-color: white;
    border: 1px solid black;
    min-height: 32px;
    padding-left: 60px;
    padding-right: 60px;
    border-radius: 25px;
    margin-top: 80px;
}

#startBTN:hover {
    background-color: #d8ef9b;
}

h1 {
    font-size: 1.4em;
}

nav {
    display: flex;
    flex: auto auto auto;
    justify-content: space-between;
    background-color: #444;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 8%;
    overflow: hidden;
    z-index: 100;
    border-bottom: 0.7vh solid #76B2BA;
}

nav > * {
    flex: auto auto auto;
}

.links {
    position: relative;
    left: 0;
    padding: 0;
}

.links {
    width: 20em;
    padding: 0px;
}
.links p {
    font-size: 2vh;
    margin-top: 2.8vh;
    float: right;
    margin-right: 1vw;
}

.logo {
    height: 100%;
}

.logo img {
    height: 70%;
    margin-top: 7.8%;
}

nav > a {
    color: white;
    text-decoration: none;
    padding: 1em 3em;
    margin: 0 0.1em;
    width: 10em;
    font-size: 1em;
}

nav a:hover {
    color: var(--btn_hover);
}

a {
    color: white;
}
.tringo-toggle {
    width: 20em;
    display: flex;
    align-items: center;
}
.info:hover + .spanInfoButton{
    transition: opacity 200ms ease-out;
    visibility: visible;
    opacity: 1;
}
.info:hover {
    cursor: pointer;
}
.info {
    background: url("../assets/info-icon.png") no-repeat;
    background-size: contain;
    height: 40%;
    width: 6%;
    margin: 0 0 0 0.5vw;
    min-width: 32px;
 /* tip button not visible in main*/
    display: none;
}

.spanInfoButton {
    font-size: 1em;
    padding: 0 0 0 0.2vw;
    visibility: hidden;
    opacity: 0;
    color: white;
}

        @media only screen and (max-width: 800px) {
        .spanInfoButton {
        font-size: 0.6em;
        }
    }

</style>
